<template>
    <div class="recent-upload">
        <div class="header">
            <div class="go-back" @click="goBack">返回</div>
            <div class="line">|</div>
            <div>最近上传</div>
        </div>
        <div v-if="tableData && tableData.length">
            <!-- 筛选行 -->
            <div class="select-box">
                <div class="select-item">
                    <div class="select-label">状态</div>
                    <div class="select-input status">
                        <veui-select
                            v-model="formData.status"
                            :options="statusList"
                            :multiple="true"
                            @change="handleSearch"
                        >
                            <template
                                #selected="{selected}"
                            >{{ selected[0].label
                            }}{{ selected.length > 1 ? `等${selected.length}个` : '' }}
                            </template>
                        </veui-select>
                    </div>
                </div>
                <div class="select-item">
                    <div class="select-label">日期</div>
                    <div class="select-date">
                        <veui-date-picker
                            v-model="formData.date"
                            range
                            clearable
                            @select="handleSearch"
                        />
                    </div>
                </div>
                <div class="select-item">
                    <div class="select-input">
                        <veui-input
                            v-model="formData.caseName"
                            class="name-input"
                            placeholder="请输入案例名称"
                            @change="handleSearch"
                        />
                    </div>
                </div>
                <div class="add-btn" @click="addContent">添加内容</div>
            </div>
            <!-- 列表 -->
            <section class="content-list">
                <veui-table
                    :data="tableData"
                    key-field="id"
                >
                    <veui-table-column
                        field="id"
                        title="文件ID"
                        width="130"
                    />
                    <veui-table-column
                        field="name"
                        title="文件名称"
                        width="250"
                    >
                        <template #default="{name}">
                            <div class="name">{{ name }}</div>
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="type"
                        title="类型"
                        width="130"
                    />
                    <veui-table-column
                        field="status"
                        title="状态"
                        width="130"
                    >
                        <template #default="{status}">
                            <div>{{ status | filterStatus }}</div>
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="date"
                        title="上传时间"
                    >
                        <template #default="{date}">
                            <div>{{ date | filterDate }}</div>
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="operation"
                        title="操作"
                        width="180"
                        align="center"
                        fixed="right"
                    >
                        <template #default="{status}">
                            <veui-button
                                v-if="status === 1"
                                ui="text"
                                class="view-btn"
                            >
                                查看
                            </veui-button>
                            <veui-button
                                v-if="status === 2"
                                ui="text"
                                class="view-btn"
                            >
                                重试
                            </veui-button>
                        </template>
                    </veui-table-column>
                </veui-table>
            </section>
            <!-- 分页 -->
            <section v-if="total" class="pagination">
                <veui-pagination
                    :page="pn"
                    :page-size="rn"
                    :total="total"
                    @redirect="handleSearch"
                />
            </section>
        </div>
        <!-- 没有上传过文件 -->
        <div v-else class="no-files">
            <div class="title">您还未没有上传文件至{{ userInfo.name }}律师的知识库</div>
            <div class="sub-title">一键上传您专属的案例内容、问答语料以及文章访谈等知识内容，提升智能体专业度，更快为您获取更多高价值用户！</div>
            <div class="upload-box">
                <fileUpload/>
            </div>
        </div>
    </div>
</template>

<script>
// 最近上传页
import {Select, Input, DatePicker, Table, Column, Pagination, Button} from 'veui';
import dayjs from 'dayjs';
import fileUpload from './fileUpload.vue';
import {mapState} from 'vuex';

export default {
    name: '',
    components: {
        'veui-select': Select,
        'veui-input': Input,
        'veui-date-picker': DatePicker,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-pagination': Pagination,
        'veui-button': Button,
        fileUpload
    },
    data() {
        return {
            formData: {}, // 筛选数据
            statusList: [
                {
                    label: '解析成功',
                    value: 1
                },
                {
                    label: '解析失败',
                    value: 2
                }
            ],
            tableData: [{
                id: '离婚案件',
                name: '张阿三的离婚事件张阿三的离婚事件',
                type: '案例内容',
                status: 2,
                date: 1724904963
            }, {
                id: '离婚案件',
                name: '张阿三的离婚事件',
                type: '案例内容',
                status: 2,
                date: 1724904963
            }],
            total: 10,
            pn: 1,
            rn: 10
        };
    },
    filters: {
        filterDate(date) {
            return date ? dayjs(date * 1000).format('YYYY-MM-DD HH:mm:ss') : '-';
        },
        filterStatus(status) {
            let list = ['', '解析成功', '解析失败'];
            return status ? list[status] : '-';
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.lawStore.userInfoNew?.lawyer_info || {}
        })
    },
    methods: {
        // 添加内容
        addContent() {
            this.$emit('addContent');
        },
        // 筛选
        handleSearch() {
        },
        goBack() {
            this.$emit('hideRecentUpload');
        }
    }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/law-table.less";

.recent-upload {
    border-radius: 8px;
    border: 1px solid #fff;
    padding: 25px 0;
    position: relative;
    overflow: hidden;
    height: 100%;
    background: #fff;

    .header {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333;
        line-height: 14px;
        display: flex;
        position: relative;
        border-bottom: 1px solid #e9ecf3;
        padding: 0 24px 25px;

        .go-back {
            position: relative;
            padding-left: 20px;
            cursor: pointer;

            &::before {
                height: 16px;
                width: 16px;
                position: absolute;
                content: "";
                left: 0;
                top: -1px;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/left.png") no-repeat center / 100% 100%;
            }
        }

        .line {
            padding: 0 10px;
        }
    }

    .select-box {
        position: relative;
        padding: 24px;
        display: flex;
        align-content: center;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333;
        line-height: 14px;
        text-align: left;

        .select-item {
            display: flex;
            align-items: center;
            margin-right: 24px;

            .select-label {
                margin-right: 14px;
            }

            .select-input {
                width: 154px;
                height: 40px;

                /deep/.veui-select {
                    width: 100%;

                    .veui-input {
                        height: 40px;
                        border: 1px solid #e9ecf3;
                        border-radius: 8px;
                    }

                    .veui-select-trigger {
                        padding-left: 11px;
                    }
                }
            }

            .select-date {
                /deep/.veui-date-picker-range {
                    width: 260px;
                }

                /deep/.veui-date-picker-trigger {
                    height: 40px;
                    border: 1px solid #e9ecf3;
                    border-radius: 8px;
                }
            }

            .veui-input {
                width: 154px;
                height: 40px;
                border: 1px solid #e9ecf3;
                border-radius: 8px;
            }
        }

        .add-btn {
            width: 96px;
            height: 40px;
            background: #05f;
            border-radius: 5px;
            font-size: 16px;
            color: #fff;
            line-height: 40px;
            text-align: center;
            position: absolute;
            right: 24px;
            cursor: pointer;
        }
    }

    .content-list {
        padding: 0 24px;

        .view-btn {
            color: rgba(0, 85, 255, 1);
            cursor: pointer;
        }

        .name {
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .pagination {
        margin-top: 25px;
        margin-right: 24px;
        text-align: right;
    }

    .no-files {
        position: relative;
        padding: 24px;

        .title {
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #1e1f24;
            line-height: 18px;
            text-align: left;
        }

        .sub-title {
            margin-top: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #848691;
            line-height: 12px;
            text-align: left;
        }

        .upload-box {
            margin-top: 24px;
        }
    }
}
</style>